import { Icon } from 'ant-design-vue';
import Vue from 'vue';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1532268_w9scrpv2c0o.js',
});
Vue.component('icon-font', IconFont);
